import { render, staticRenderFns, recyclableRender, components } from "./insuranceApplication.vue?vue&type=template&id=3c4224c6&scoped=true&"
var renderjs
import script from "./insuranceApplication.vue?vue&type=script&lang=js&"
export * from "./insuranceApplication.vue?vue&type=script&lang=js&"
import style0 from "./insuranceApplication.vue?vue&type=style&index=0&lang=css&"
import style1 from "./insuranceApplication.vue?vue&type=style&index=1&id=3c4224c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4224c6",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/insuranceApplication/insuranceApplication.vue"
export default component.exports